import {useState} from 'react';
import {ShieldCheck} from 'lucide-react';
import {Ticket} from '../../types';

export const TicketMessage = ({ticket}: {ticket: Ticket}) => {
  const [expanded, setExpanded] = useState(false);
  const customerId = ticket.number.toString().slice(-2);
  const created = new Date(ticket.created_at);
  return <div className="message-box">
    <div className="message-top">
      <div className="sender"><span className="sender-avatar">C{customerId}</span><div>
        <div className="sender-name" data-testid="ticket-customer">Customer {customerId}</div>
        <div className="sender-email">Customer message</div>
      </div></div>
      <time data-testid="ticket-created-at">{created.toLocaleDateString('en-US', {month: 'short', day: 'numeric'})} · {created.toLocaleTimeString('en-US', {hour: 'numeric', minute: '2-digit'})}</time>
    </div>
    <div className={`message-body ${expanded ? 'expanded' : ''}`} data-testid="ticket-message">{ticket.message}</div>
    <div className="message-footer">
      <span className="privacy-badge" data-testid="ticket-redaction-notice"><ShieldCheck size={12}/>Common identifiers masked</span>
      <button className="expand-message" onClick={() => setExpanded(!expanded)} aria-expanded={expanded} data-testid="ticket-expand-message">{expanded ? 'Collapse message' : 'Expand message'}</button>
    </div>
  </div>;
};